import {
  ApiResponse,
  DashboardStatsResponse,
  TrackVisitRequest,
  TrackVisitResponse,
} from "../../types/admin";
import httpClient from "../httpClient";
import { ensureArray, sanitizeDataResponse } from "./helpers";

const sanitizeDashboardStats = (data: DashboardStatsResponse): DashboardStatsResponse => ({
  ...data,
  visitsByCountry: ensureArray(data.visitsByCountry),
  visitsByCity: ensureArray(data.visitsByCity),
  visitsByBrowser: ensureArray(data.visitsByBrowser),
  visitsByOs: ensureArray(data.visitsByOs),
  visitsByDevice: ensureArray(data.visitsByDevice),
  visitsPerDay: ensureArray(data.visitsPerDay),
  visitsByHour: ensureArray(data.visitsByHour),
  visitsByIp: ensureArray(
    data.visitsByIp ||
      ((data as unknown as { visitsPerIp?: unknown[] }).visitsPerIp as DashboardStatsResponse["visitsByIp"]) ||
      ((data as unknown as { topIps?: unknown[] }).topIps as DashboardStatsResponse["visitsByIp"]) ||
      ((data as unknown as { visitsByIPAddress?: unknown[] }).visitsByIPAddress as DashboardStatsResponse["visitsByIp"])
  ),
});

export const visitorsApi = {
  track: (payload: TrackVisitRequest): Promise<ApiResponse<TrackVisitResponse>> =>
    httpClient.postPublic("/Visitors/track", payload),

  dashboard: async (
    params?: { daysForDaily?: number; topCountries?: number; topCities?: number }
  ): Promise<ApiResponse<DashboardStatsResponse>> => {
    const query = new URLSearchParams();

    if (params?.daysForDaily !== undefined) query.set("daysForDaily", String(params.daysForDaily));
    if (params?.topCountries !== undefined) query.set("topCountries", String(params.topCountries));
    if (params?.topCities !== undefined) query.set("topCities", String(params.topCities));

    const qs = query.toString();
    const path = qs ? `/Visitors/dashboard?${qs}` : "/Visitors/dashboard";

    const response = await httpClient.get<DashboardStatsResponse>(path);
    return sanitizeDataResponse(response, sanitizeDashboardStats);
  },
};
